import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/auth-context';

import './styles/Home.css';

const ReferralMarketingProgramAgreement = () => {
    
    const auth = useAuth();
    const navigate = useNavigate();

    return (
        <div>
            <iframe src="https://docs.google.com/document/d/e/2PACX-1vSqalrxhNEeTkIPw7Pkrgx4D0UGPGbIS3iYgLLEPJRqYFFNR19nGoetgeQ9USHIEA/pub?embedded=true"
              width="800" height="1200"
            >
            </iframe>

            
        </div>

    )
}

export default ReferralMarketingProgramAgreement;